module.exports = __webpack_public_path__ + "img/linux.2bf747f0.svg";